// extracted by mini-css-extract-plugin
export var callCard = "_rj-0";
export var callMessageButton = "_rj-1";
export var helpIcon = "_rj-3";
export var helpIconContainer = "_rj-4";
export var verticalDivider = "_rj-2";